/**
 * Indian mobile (no country code): digits only, max 10.
 * If the user pastes ``+91`` or a longer digit string, keep the **last** 10 digits.
 */
export function sanitizeIndianMobile10Input(raw) {
  const d = String(raw || "").replace(/\D/g, "");
  if (d.length <= 10) return d;
  return d.slice(-10);
}

/** True when the value is exactly 10 digits (after optional sanitization). */
export function isIndianMobile10(value) {
  return /^\d{10}$/.test(String(value || "").trim());
}
